{
    "search": "Søk",
    "closePanel": "Lukk panel",
    "predefined": {
        "predefinedText": "Forhåndsdefinert Tekst",
        "filter": "Filter",
        "blank": "<Tom>"
    },
    "library": {
        "textLibrary": "Tekstbibliotek",
        "selectLanguage": "Velg språk",
        "texts": "Tekster",
        "page": "Side",
        "of": "av",
        "all": "Alle",
        "group": "Gruppe",
        "language": "Språk",
        "validFrom": "Gyldig fra",
        "validTo": "Gyldig til",
        "name": "Navn",
        "createdTime": "Laget tid",
        "createdByUserName": "Opprettet av brukernavn",
        "modifiedTime": "Endret tid",
        "modifiedByUserName": "Modifisert av brukernavn",
        "sortby": "Sorter etter",
        "ascending": "Stigende",
        "descending": "Synkende",
        "copyText": "Kopier tekst",
        "textHasExpired": "Teksten er utløpt.",
        "copied": "Kopiert!",
        "insertTextFromLibrary": "Sett inn tekst fra biblioteket",
        "copyFullTextToClipboard": "Trykk ENTER for å kopiere teksten",
        "copyPartialTextToClipboard": "Trykk Shift + ENTER for å vise og kopiere deler av teksten",
        "danish": "dansk",
        "english": "engelsk",
        "finnish": "finsk",
        "norwegian": "norsk",
        "swedish": "svensk"
    },
    "distribution": {
        "distribution": "Fordeling",
        "centralDistribution": "Sentral distribusjon",
        "localPrint": "Lokal utskrift",
        "email": "E-post",
        "archiveOnly": "Kun arkiv",
        "successDocumentPublishment": "Dokumentet ble publisert",
        "successDocumentDistribution": "Dokumentet ble distribuert",
        "generatingPdf": "Genererer PDF...",
        "pleaseWaitProcessing": "Vennligst vent mens vi behandler forespørselen din.",
        "download": "Last ned",
        "print": "Skriv ut",
        "close": "Lukk"
    },
    "discard": {
        "discardDocument": "Forkast Dokumentet",
        "areYouSureToDiscardDocument": "Er du sikker på at du vil forkaste dokumentet?"
    },
    "insertPoint": {
        "insertedText": "Innsatt tekst"
    },
    "inputFieldValidation": {
        "required": "Obligatorisk",
        "atLeast": "Minst",
        "atMost": "Maksimalt",
        "characterRequired": "tegn kreves",
        "invalid": "ugyldig"
    },
    "mandatoryFieldBanner": {
        "message": "Dette dokumentet har obligatoriske felt som ikke er fylt ut.",
        "browse": "Bla gjennom",
        "moveDown": "Flytt til neste obligatoriske felt som ikke er fylt ut",
        "moveUp": "Flytt til forrige obligatoriske felt som ikke er fylt ut"
    },
    "breakTable": {
        "insertRowAbove": "Sett inn rad ovenfor",
        "insertRowBelow": "Sett inn rad nedenfor",
        "deleteRow": "Slett rad",
        "moveUp": "Flytt opp",
        "moveDown": "Flytt ned"
    }
}